exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-list__tile__action[data-v-2f6ff61f] {\n    min-width: 35px;\n}\n.v-icon[data-v-2f6ff61f] {\n    color: #8edfb4;\n}\n.v-list__tile__title[data-v-2f6ff61f] {\n    font-weight: 700; \n    font-size: 21px;\n    color: #fff;\n}\n\n", ""]);

// exports
